import React, { useState } from 'react';
import './NFTCard.css';
import NFTModal from './NFTModal';

function NFTCard({ nft, onModalOpen, onModalClose }) {
  const [showModal, setShowModal] = useState(false);

  const handleModalToggle = (show) => {
    setShowModal(show);
    if (show) {
      onModalOpen();
    } else {
      onModalClose();
    }
  };

  return (
    <>
      <div className="nft-card" onClick={() => handleModalToggle(true)}>
        <div className="nft-image-container">
          <img src={nft.keyimage} alt={nft.capyid} className="nft-image" />
        </div>
        <div className="nft-info">
          <div className="nft-header">
            <h3>{nft.capyid}</h3>
            <div className="nft-stats">
              <span className="rarity-score">RS: {nft.rarityScore}%</span>
              <span className="rank-display">Rank: {nft.rank}</span>
            </div>
          </div>
        </div>
      </div>
      {showModal && <NFTModal nft={nft} onClose={() => handleModalToggle(false)} />}
    </>
  );
}

export default NFTCard;